import axios from "axios";
import Vue from "vue";
import { Dialog } from "vant";
// 环境value
let _isDev = process.env.NODE_ENV === "development";
// webpack require.context 转为对象包装函数
export const webpackRequire2obj = (r, exinclude) => {
  let contents = {};
  const paths = r.keys().filter((p, i) => {
    return exinclude.indexOf(p) == -1;
  });
  for (let p of paths) {
    let fn = r(p).default ? r(p).default : r(p);
    let k = p.match(/(\w+-?\w+).js$/)[1];
    contents[k] = fn;
  }
  return contents;
};
export const formatTime = timestamp => {
  return false;
  //   let date = new Date(timestamp);
  //   const year = date.getFullYear();
  //   const month = date.getMonth() + 1;
  //   const day = date.getDate();
  //   const hour = date.getHours();
  //   const minute = date.getMinutes();
  //   const second = date.getSeconds();

  //   return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
};
//检测密码格式
export const checkPassword = value => {
  return false;
  //   let reg = /^[a-zA-Z0-9]{6,16}$/;
  //   if ((reg.test(value))) {
  //     return true;
  //   }
  //   return false;
};

export const formatContentLink = content => {
  let reg = /href=".+?">/g;
  let res = "" + content;
  let strs = res.match(reg);
  if (strs && strs.length > 0) {
    for (let i = 0; i < strs.length; i++) {
      let str = "" + strs[i];
      if (str.indexOf("@@1") > -1) {
        //信息页
        let str1 = "" + str.split('href="')[1];
        let str2 = "" + str1.split("@@1")[0];
        let str3 = 'href="/#/information/informationDetail/' + str2 + '">';
        res = res.replace(str, str3);
      } else if (str.indexOf("@@2") > -1) {
        //服务详情页
        let str1 = "" + str.split('href="')[1];
        let str2 = "" + str1.split("@@2")[0];
        let str3 = 'href="/#/serviceDetail?serviceId=' + str2 + '">';
        res = res.replace(str, str3);
      } else if (str.indexOf("@@4") > -1) {
        //分类页
        let str3 = 'href="/#/serviceType">';
        res = res.replace(str, str3);
      } else if (str.indexOf('href="/mall/v1.0/diy_page/') > -1) {
        // <a href="/mall/v1.0/diy_page/bdb0a230-c43a-4b02-8f5a-c26ad263e258">
        // // /mall/v1.0/diy_page/
        // 自定义h5页面
        let str1 = "" + str.split('href="/mall/v1.0/diy_page/')[1];
        let str3 = 'href="/#/diy_page/' + str1;
        // let str3 = 'href="/#/pageH5?id=' + str1;
        res = res.replace(str, str3);
      }
    }
  }
  return res;
};
/**
 * 去中心化
 * @param {上下文} requireContext
 * @param {排除文件} exinclude
 */
export const deCentralization = (
  requireContext,
  fn = (a, b) => ({
    ...a,
    ...b
  })
) => {
  // console.log(requireContext.keys())
  const sourceMap = (r => {
    return requireContext.keys().map(k => {
      return r(k).default;
    });
  })(requireContext);
  // console.log(sourceMap)
  return sourceMap.reduce(fn);
};

export const lazyVue = (name, index = false) => () =>
  import(`@/views/${name}${index ? "/index" : ""}.vue`);
/**
 * 开发输出log
 * @param {消息} msg
 */
export const log = msg => {
  if (_isDev && console && console.log) {
    // console.log(msg)
  }
};
/**
 * 构造fromData数据
 * @param {文件} f
 * @param {资源远程目录} key
 * @param {formData文件名} name
 */
export const appendFormData = (f, name, key = "") => {
  let formData = new window.FormData();
  formData.append(name, f);
  return new Promise((resolve, reject) => {
    getUploadToken().then(token => {
      formData.append("token", token);
      resolve(formData);
    });
  });
};
/**
 * 简易上传（头像上传）
 * @param {文件} f
 * @param {host} host
 * @param {资源远程目录} key
 */
export const uploadFile = (f, host, key) => {
  return new Promise((resolve, reject) => {
    appendFormData(f, "file", key).then(fd => {
      axios
        .post(host, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(d => {
          resolve(d.data);
        })
        .catch(res => {
          let _response = res.response;
          Vue.$vux.toast.show({
            text:
              _response.data && _response.data.error
                ? _response.data.error
                : "上传错误",
            type: "warn"
          });
          Cookies("Upload_Token", undefined);
          reject(_response);
        });
    });
  });
};

/**
 * 判断空数组或对象
 * @param value
 */
export const isEmpty = value => {
  return Object.keys(value).length === 0;
};

/**
 * 截取小数点位数
 * @param {数值} value
 * @param {小数点位数} len
 */
export const toFixed = (value, len = 2) => {
  return value ? parseFloat(value).toFixed(len) : 0;
};

/**
 * 获取style样式
 */
export const getStyle = (element, attr) => {
  let target;
  // scrollTop 获取方式不同，不属于style，而且只有document.body才能用
  if (attr === "scrollTop") {
    target = element.scrollTop;
  } else if (element.currentStyle) {
    target = element.currentStyle[attr];
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr];
  }
  return target;
};

/**
 * 数组删除指定元素
 */
export function removeByValue(arr, val) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] == val) {
      arr.splice(i, 1);
      break;
    }
  }
}
export function confirmDialog(message, confirmFn, cancelFn) {
  return Dialog.confirm({
    className: "w70p",
    message: `<div class="tc fc3">${message}</div>`
  })
    .then(() => {
      if (confirmFn && typeof confirmFn === "function") {
        confirmFn();
      }
    })
    .catch(() => {
      if (cancelFn && typeof cancelFn === "function") {
        cancelFn();
      }
    });
}
// 按需加载腾讯地图qqMap对象
export function TMap(KEY, libraries) {
  return new Promise(function(resolve, reject) {
    window.init = function() {
      resolve(qq); //注意这里
    };
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://map.qq.com/api/js?v=2.exp&callback=init&key=${KEY}&libraries=${libraries}`;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
export { dataToUnderline, fmt } from "vma-vue-assist/dist/static/js/utils";

/**
 * 数组删除指定元素
 */
export function isweixin() {
  const ua = window.navigator.userAgent.toLowerCase();
  console.log({ ua }, ua.match(/MicroMessenger/i));
  if (ua.match(/MicroMessenger/i)) {
    return true;
  } else {
    return false;
  }
}

export function IsPC(isInCludeChromeDevice = 1) {
  let flag = true;
  if (
    isInCludeChromeDevice &&
    (navigator.platform.toLowerCase().match(/win/i) ||
      navigator.platform.toLowerCase().match(/mac/i))
  ) {
    return flag;
  } else {
    let ua = navigator.userAgent;
    let Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    ];
    for (let v = 0; v < Agents.length; v++) {
      if (ua.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }
}

// let browser = {
//     versions: function () {
//         let u = window.navigator.userAgent;
//         return {
//             trident: u.indexOf('Trident') > -1, //IE内核
//             presto: u.indexOf('Presto') > -1, //opera内核
//             webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
//             gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
//             mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
//             ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
//             android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
//             // iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者安卓QQ浏览器
//             iPhone: u.indexOf('iPhone') > -1, //是否为iPhone浏览器
//             iPad: u.indexOf('iPad') > -1, //是否为iPad
//             webApp: u.indexOf('Safari') == -1,//是否为web应用程序，没有头部与底部
//             weixin: u.indexOf('MicroMessenger') == -1 //是否为微信浏览器
//         };
//     }()
// }
// console.log(" 是否为移动终端: " + browser.versions.mobile);
// console.log(" 是否为PC: " + IsPC());
// console.log(" ios终端: " + browser.versions.ios);
// console.log(" android终端: " + browser.versions.android);
// console.log(" 是否为iPhone: " + browser.versions.iPhone);
// console.log(" 是否iPad: " + browser.versions.iPad);
// console.log(browser.versions);
// console.log(window.navigator.userAgent);
import dicApi from "@/apis/src/dictionary.js";
export const serveUnit = async (cb, available) => {
  let unitlist = {};
  let unitlistres = {};
  let code = "dan_wei_guan_li";
  let params = {};
  if (available) {
    params = { status: 1 };
  } else {
    params = { isDelete: 2 };
  }
  try {
    let res = await dicApi.list([code], params);
    // let res = await getuinitdic();
    if (res && res["danWeiGuanLi"] && res["danWeiGuanLi"]["dictionaryList"]) {
      unitlistres = res["danWeiGuanLi"]["dictionaryList"];
      unitlistres.forEach(o => {
        unitlist[o.id] = o.name;
      });
    }
  } catch (error) {
    unitlist = {};
    unitlistres = {};
    console.error(error);
  }
  if (cb) {
    const fn = _ => unitlist[_] || "-";
    cb(fn, unitlist, unitlistres);
  }
};
// export const transformUnit = (unit) => {
//     switch (parseInt(unit)) {
//         case 1:
//             return "小时";
//         case 2:
//             return "台";
//         case 3:
//             return "平方";
//         case 4:
//             return "间";
//         case 5:
//             return "次";
//         case 6:
//             return "片";
//         case 7:
//             return "瓶";
//         case 8:
//             return "双";
//         case 9:
//             return "包";
//         case 10:
//             return "个";
//     }
// }
export const addTailingComma = (idx, len, seperatorType) => {
  return idx < len ? seperatorType : " ";
};



// WEBPACK FOOTER //
// ./src/utils/index.js